import React from 'react';
import './Hero.css';

const Hero = () => {
  const open = (url) => window.open(url, '_blank');
  return (
    <section id="overview" className="hero section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h2 className="hero-title">Harnessing Global Compute Power<br />for Efficient, Low-Cost<br />Distributed LLM Inference</h2>
            {/* <p className="hero-description">Tap into the Power of PolyLink</p> */}

          </div>
          <div className="hero-image">
            <div className="gpu-network">
              <div className="network-title">Open AI Computing Infrastructure</div>
              <div className="gpu-cluster">
                <div className="gpu-node gpu-node-1">
                  <div className="gpu-icon">🖥</div>
                </div>
                <div className="gpu-node gpu-node-2">
                  <div className="gpu-icon">💻</div>
                </div>
                <div className="gpu-node gpu-node-3">
                  <div className="gpu-icon">📱</div>
                </div>
                <div className="gpu-node gpu-node-4">
                  <div className="gpu-icon">💻</div>
                </div>
                <div className="gpu-node gpu-node-5">
                  <div className="gpu-icon">🖥</div>
                </div>
                <div className="gpu-node gpu-node-6">
                  <div className="gpu-icon">📱</div>
                </div>
                <div className="gpu-node gpu-node-7">
                  <div className="gpu-icon">🖥</div>
                </div>
                <div className="gpu-node gpu-node-8">
                  <div className="gpu-icon">💻</div>
                </div>
                
                {/* Connection lines */}
                <div className="connection-line line-1"></div>
                <div className="connection-line line-2"></div>
                <div className="connection-line line-3"></div>
                <div className="connection-line line-4"></div>
                <div className="connection-line line-5"></div>
                <div className="connection-line line-6"></div>
                <div className="connection-line line-7"></div>
                <div className="connection-line line-8"></div>
                
                {/* Data flow particles */}
                <div className="data-particle particle-1"></div>
                <div className="data-particle particle-2"></div>
                <div className="data-particle particle-3"></div>
                <div className="data-particle particle-4"></div>
                <div className="data-particle particle-5"></div>
                <div className="data-particle particle-6"></div>
                <div className="data-particle particle-7"></div>
                <div className="data-particle particle-8"></div>
              </div>
              {/* <div className="network-info">
                <div className="info-item">
                  <span className="info-number">397</span>
                  <span className="info-text">Active Users</span>
                </div>
                <div className="info-item">
                  <span className="info-number">160+</span>
                  <span className="info-text">GPU Cards</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 